import {
  IFreezeTablesSearchParams,
  IFreezeReleaseCalculationsTableReport,
  IFreezeTablesProps,
} from "../../../Interfaces/freeze";
import { getFreezeReleaseCalculationsTable } from "../../../Requests/freeze";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { Additional } from "./Additional";

const ReleaseCalculations = ({ searchParam }: IFreezeTablesProps) => {
  return (
    <TableTemplate<
      IFreezeTablesSearchParams,
      IFreezeReleaseCalculationsTableReport
    >
      refreshTableTime={5000}
      getDataTable={(searchParam, offset, pageSize, sortingType) =>
        getFreezeReleaseCalculationsTable(
          searchParam,
          offset,
          pageSize,
          sortingType || ""
        )
      }
      TableUI={({ reports, onAction, sortingType, setSortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          withSelect
          AdditionalBody={Additional}
          sortingType={sortingType}
          setSortingType={setSortingType}
        />
      )}
      withSort
      searchParameters={searchParam}
    />
  );
};

export default ReleaseCalculations;
